// src/components/JoyrideBookingEmbed.jsx
import React, { useEffect, useState } from "react";
import BuukkeriBookingEmbed from "../../components/BuukkeriBookingEmbed/BuukkeriBookingEmbed.jsx";

/**
 * Joyriden oma wrapperi yleisen Buukkeri-embedin päälle.
 *
 * Tämä säilyttää Joyriden omat tekstit ja oletusasetukset,
 * mutta varsinainen embed-logiikka tulee yleisestä komponentista.
 */
export default function JoyrideBookingEmbed({
  title = "Katso hinta ja kysy saatavuutta",
  description = "Valitse päivä, asiakastyyppi, tapahtumapaikka ja esiintymisen pituus. Näet kokonaishinnan matkakuluineen ennen tiedustelun lähettämistä. Tiedustelu ei sido sinua varaukseen.",
}) {

  const getIsDarkTheme = () =>
    typeof document !== "undefined" &&
    document.documentElement.classList.contains("dark");

  const [isDarkTheme, setIsDarkTheme] = useState(getIsDarkTheme);

  useEffect(() => {
    if (typeof document === "undefined") return;

    const root = document.documentElement;

    const syncTheme = () => {
      setIsDarkTheme(root.classList.contains("dark"));
    };

    syncTheme();

    const observer = new MutationObserver(syncTheme);
    observer.observe(root, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const hostTheme = isDarkTheme
    ? {
        accentColor: "#05F2F2",
        titleColor: "#05F2F2",
        descriptionColor: "#F2F2F2",
        cardBackground: "rgba(7, 58, 89, 0.78)",
        cardBorderColor: "transparent",
        cardGlowColor: "transparent",
        poweredByColor: "rgba(242, 242, 242, 0.78)",
      }
    : {
        accentColor: "#073A59",
        titleColor: "#073A59",
        descriptionColor: "#073A59",
        cardBackground: "rgba(255, 255, 255, 0.92)",
        cardBorderColor: "rgba(7, 58, 89, 0.16)",
        cardGlowColor: "rgba(7, 58, 89, 0.08)",
        poweredByColor: "rgba(7, 58, 89, 0.72)",
      };

  return (
    <BuukkeriBookingEmbed
      slug="bilebandi-joyride"
      embedKey="5aeaba5c6c5e6574d2c9542f5600a68b"
      embedTheme={isDarkTheme ? "joyride-dark" : "joyride-light"}
      title={title}
      description={description}
      accentColor={hostTheme.accentColor}
      titleColor={hostTheme.titleColor}
      descriptionColor={hostTheme.descriptionColor}
      cardBackground={hostTheme.cardBackground}
      cardBorderColor={hostTheme.cardBorderColor}
      cardGlowColor={hostTheme.cardGlowColor}
      poweredByColor={hostTheme.poweredByColor}
      sectionId="varaa"
      minHeightMobile={1250}
      minHeightTablet={1150}
      minHeightSmallDesktop={980}
      minHeightDesktop={900}
    />
  );
}